__turbopack_context__.v({
  "button": "PlasmicContactModalMessageSent-module__fd-0kG__button",
  "dialogClose": "PlasmicContactModalMessageSent-module__fd-0kG__dialogClose",
  "fill2": "PlasmicContactModalMessageSent-module__fd-0kG__fill2",
  "h2__aJ2U8": "PlasmicContactModalMessageSent-module__fd-0kG__h2__aJ2U8",
  "h2__o6Lo0": "PlasmicContactModalMessageSent-module__fd-0kG__h2__o6Lo0",
  "icon": "PlasmicContactModalMessageSent-module__fd-0kG__icon",
  "messageSentModal": "PlasmicContactModalMessageSent-module__fd-0kG__messageSentModal",
  "svg__epBm": "PlasmicContactModalMessageSent-module__fd-0kG__svg__epBm",
  "svg__zh8TB": "PlasmicContactModalMessageSent-module__fd-0kG__svg__zh8TB",
  "text2": "PlasmicContactModalMessageSent-module__fd-0kG__text2",
});
